import {
  FIELD_BASE,
  FIELD_DISABLED,
  FIELD_ERROR,
  FIELD_LABEL,
  fieldState,
} from "./formFieldStyles";

const FormInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  type = "text",
  required = false,
  placeholder,
  disabled = false,
  suffix,
}) => (
  <div>
    {label && (
      <label htmlFor={name} className={FIELD_LABEL}>
        {label} {required && <span className="text-danger-500">*</span>}
      </label>
    )}

    <div className={suffix ? "flex items-stretch gap-2" : undefined}>
      <input
        id={name}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        className={`${FIELD_BASE} ${fieldState(error)} ${
          disabled ? FIELD_DISABLED : "text-gray-900"
        }`}
      />
      {suffix && (
        <span className="flex shrink-0 items-center rounded-lg border border-gray-200 bg-gray-50 px-3 text-[13px] font-medium text-gray-600">
          {suffix}
        </span>
      )}
    </div>

    {error && <p className={FIELD_ERROR}>{error}</p>}
  </div>
);

export default FormInput;
